// extracted by mini-css-extract-plugin
export var chevron = "_ir-2";
export var chevronRotated = "_ir-3";
export var header = "_ir-1";
export var section = "_ir-0";